const BOARDS = [
  { id: 'board-1', name: 'Board 1' },
  { id: 'board-2', name: 'Board 2' },
  { id: 'board-3', name: 'Board 3' },
  { id: 'board-4', name: 'Board 4' },
  { id: 'board-5', name: 'Board 5' },
  { id: 'board-6', name: 'Board 6' },
  { id: 'board-7', name: 'Board 7' },
]

export default BOARDS
